import { createContext, useContext, useMemo, type ReactNode } from "react";
import { localSupabaseClient, type TypedSupabaseClient } from "../../../shared/api/supabase";
import { PublicAppError } from "../../../shared/lib/errors";
import { createPlatformApi, type PlatformApi } from "../api/platform-api";

const PlatformApiContext = createContext<PlatformApi | null>(null);

interface PlatformApiProviderProps {
  children: ReactNode;
  client?: TypedSupabaseClient | null;
  api?: PlatformApi;
}

export function PlatformApiProvider({
  children,
  client = localSupabaseClient,
  api,
}: PlatformApiProviderProps) {
  const value = useMemo(() => {
    if (api !== undefined) return api;
    if (client === null) return null;
    return createPlatformApi(client);
  }, [api, client]);

  if (value === null) {
    throw new PublicAppError(
      "missing_public_config",
      "A configuração pública da aplicação não está disponível.",
    );
  }
  return <PlatformApiContext.Provider value={value}>{children}</PlatformApiContext.Provider>;
}

export function usePlatformApi(): PlatformApi {
  const api = useContext(PlatformApiContext);
  if (api === null) throw new Error("PlatformApiProvider ausente");
  return api;
}
